import React, { useEffect } from 'react'
import { Input, InputBaseProps, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { Color, FontWeight, Value } from 'theme/style'
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { config } from 'app/config'

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'flex',
  },
  input: {
    flex: 1,
    backgroundColor: Color.Background,
    borderRadius: Value.BorderRadius_Field,
    '& input': {
      cursor: 'pointer !important',
    },
  },
}))

interface DateFieldProps {
  name: string
  value: Date
  type?: string
  onUpdate?: (name: string, value: any) => void
  onConfirm?: (name: string, value: any) => void
}
const DateField = ({ ...props }: DateFieldProps) => {
  const classes = useStyles()



  //FIELD CHANGES

  function updateField(date: any) {
    const value = date

    if (props.onUpdate == null) return
    props.onUpdate(props.name, value)
  }



  //RENDER

  return (
    <div className={classes.inputContainer}>
      <DateTimePicker
        autoOk
        className={classes.input}
        variant="inline"
        format={config.app.defaultDateTimeFormat}
        value={props.value} onChange={date => updateField(date)}
      />
    </div>
  )
}

export default DateField